import DefaultImage from "assets/Images/BrandImage1.png";

export default function UserAvatarForAnalytics({
  profileImageURL,
  username,
  email,
  additionalSubtext,
}: {
  profileImageURL: string;
  username: string;
  email: string;
  additionalSubtext?: string;
}) {
  return (
    <div className="flex items-start justify-center gap-1.5">
      <img
        alt={`${username} profile`}
        className="h-16 w-16 overflow-hidden rounded-full object-cover"
        src={profileImageURL || DefaultImage}
      />
      <div className="flex flex-1 flex-col gap-1.5 font-satoshi">
        <p className="text-lg font-semibold text-white">{username}</p>
        <p className="text-base font-medium">{email}</p>
        {additionalSubtext && <p className="text-base font-medium">{additionalSubtext}</p>}
      </div>
    </div>
  );
}
